// import { Marker, MarkerClustererF } from '@react-google-maps/api';
// import React, { Suspense } from 'react'

// function MapsMarker({ data }) {
//     if (!data || !data.length || !window.google) {
//         return null;
//     }
//     return (
//         <MarkerClustererF
//             options={{
//                 maxZoom: 12,
//                 gridSize: 60,
//             }}
//         >
//             {(clusterer) => (
//                 <>
//                     {data?.map((user) => (

//                         <Marker
//                             key={`marker-${user.id}`}
//                             position={{
//                                 lat: parseFloat(user.latitude) || 0,
//                                 lng: parseFloat(user.longitude) || 0
//                             }}
//                             clusterer={clusterer}
//                             icon={
//                                 user.icon
//                                     ? {
//                                         url: user.icon,
//                                         scaledSize: new window.google.maps.Size(35, 35),
//                                     }
//                                     : undefined
//                             }
//                             onClick={() => {
//                                 user.onClick(user);
//                             }}
//                         />
//                     ))}
//                 </>
//             )}
//         </MarkerClustererF>
//     )
// }

// export default MapsMarker
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Marker, useGoogleMap } from "@react-google-maps/api";
import Supercluster from "supercluster";

function MapsMarker({ data = [] }) {
    const map = useGoogleMap();
    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(5);

    // ✅ Update map bounds & zoom on move
    useEffect(() => {
        if (!map) return;

        const update = () => {
            const b = map.getBounds();
            const newZoom = map.getZoom();
            if (b) {
                const ne = b.getNorthEast();
                const sw = b.getSouthWest();
                setBounds([sw.lng(), sw.lat(), ne.lng(), ne.lat()]);
                setZoom(newZoom);
            }
        };

        update(); // initial
        const listener = map.addListener("idle", update);
        return () => window.google.maps.event.removeListener(listener);
    }, [map]);

    // ✅ Convert input data → GeoJSON points
    const points = useMemo(
        () =>
            data.map((user) => ({
                type: "Feature",
                properties: {
                    cluster: false,
                    userId: user.id,
                    userData: user, // ✅ store full original object
                },
                geometry: {
                    type: "Point",
                    coordinates: [
                        parseFloat(user.longitude) || 0,
                        parseFloat(user.latitude) || 0,
                    ],
                },
            })),
        [data]
    );

    // ✅ Initialize supercluster
    const supercluster = useMemo(() => {
        const cluster = new Supercluster({
            radius: 60,
            maxZoom: 18,
        });
        cluster.load(points);
        return cluster;
    }, [points]);

    // ✅ Get visible clusters
    const clusters = useMemo(() => {
        if (!bounds) return [];
        return supercluster.getClusters(bounds, Math.round(zoom));
    }, [supercluster, bounds, zoom]);

    // ✅ Marker click handler
    const handleMarkerClick = useCallback((user) => {
        if (user.onClick && typeof user.onClick === "function") {
            user.onClick(user);
        }
    }, []);

    if (!window.google || !map) return null;

    return (
        <>
            {clusters.map((feature) => {
                const [lng, lat] = feature.geometry.coordinates;
                const { cluster: isCluster, point_count: pointCount } =
                    feature.properties;

                // 🔵 Render cluster marker
                if (isCluster) {
                    return (
                        <Marker
                            key={`cluster-${feature.id}`}
                            position={{ lat, lng }}
                            icon={{
                                path: window.google.maps.SymbolPath.CIRCLE,
                                fillColor: "#1976d2",
                                fillOpacity: 0.7,
                                strokeWeight: 0,
                                scale: Math.max(25, pointCount / 2),
                            }}
                            label={{
                                text: String(pointCount),
                                color: "white",
                                fontSize: "13px",
                                fontWeight: "bold",
                            }}
                            onClick={() => {
                                const expansionZoom = Math.min(
                                    supercluster.getClusterExpansionZoom(feature.id),
                                    20
                                );
                                map.setZoom(expansionZoom);
                                map.panTo({ lat, lng });
                            }}
                        />
                    );
                }

                // 📍 Render single user marker
                const user = feature.properties.userData;

                return (
                    <Marker
                        key={`marker-${user.id}`}
                        position={{ lat, lng }}
                        icon={
                            user.icon
                                ? {
                                    url: user.icon,
                                    scaledSize: new window.google.maps.Size(35, 35),
                                }
                                : undefined
                        }
                        onClick={() => handleMarkerClick(user)} // ✅ same as old logic
                    />
                );
            })}
        </>
    );
}

export default MapsMarker;
